import CalendarHeatmap from 'react-calendar-heatmap'
import 'react-calendar-heatmap/dist/styles.css'

import ReactTooltip from 'react-tooltip'
import React from 'react'


export interface iDateCell { date: string, count: number, style?: number }
interface iActivityCalendar { dates:iDateCell[], title:string, color:string }

export const ActivityCalendar = ({dates, title, color}: iActivityCalendar) => {
    const parseDate = (date: Date) => `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`
    const getTooltipDataAttrs = (value: iDateCell) => ({ 
        'data-tip': `${
                value.count || 'No' // Numeric counter of heatmap attribute
            } ${
                title.toLowerCase().substring(0,title.length - 1)   // Remove title's attribute plural
            }${
                value.count !== 1 ? 's' : ''    // Pluralize if counter different than 1.
            } ${
                value.count ? `on ${new Date(value.date).toDateString().slice(0, 16)}` : '' // Date of the HeatMap cell.
            }.
        `   // End with Point.
    })

    return <div style={{marginTop:72, marginBottom: 128, width: 360, margin:'auto', maxWidth: '100%'}}>
        <p className="subtitle is-3" style={{color: '#ccc', marginBottom: 0}}> { title } </p>
        <CalendarHeatmap
            values={dates}
            endDate={parseDate(new Date(Number(new Date())))}
            startDate={parseDate(new Date(Number(new Date()) - 1000*60*60*24*89))}
            tooltipDataAttrs={getTooltipDataAttrs}
            classForValue={(v: iDateCell) => !v  ? 'color-empty' : `${color}-color-scale-${v.style}`}
        />
        <ReactTooltip />
    </div>
}
